import { Routes } from '@angular/router';
import {
  CmsPageComponent,
  cmsInEditorGuard,
  cmsPageTemplateResolver,
} from '@domgen/dgx-fe-cms';
import { RegistrationRoutes } from '@us-registration/util-models';
import { maintenanceGuard } from './guards/maintenance.guard';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [maintenanceGuard],
    children: [
      {
        path: 'maintenance',
        loadComponent: () =>
          import('./components/maintenance/maintenance.component').then(
            (m) => m.MaintenanceComponent
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        component: CmsPageComponent,
        canActivate: [cmsInEditorGuard],
        data: {
          cmsNodePath: '/',
          redirectTo: RegistrationRoutes.ApplianceDetails,
        },
        resolve: {
          cmsPageTemplate: cmsPageTemplateResolver,
        },
      },
      {
        path: 'error',
        loadChildren: () =>
          import('@error/shell').then((module) => module.ERROR_SHELL_ROUTES),
      },
      {
        path: 'support',
        loadChildren: () =>
          import('@support/shell').then(
            (module) => module.SUPPORT_SHELL_ROUTES
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('@us-registration/shell').then(
            (module) => module.US_REGISTRATION_ROUTES
          ),
      },
    ],
  },
];
